import React from 'react';
import { RouteObject } from 'react-router-dom';

import { AuthLayout } from './AuthLayout';
import { LoginActivity } from './LoginActivity/LoginActivity';
import { RegisterActivity } from './RegisterActivity/RegisterActivity';



export const root: RouteObject = {
  path: 'auth',
  element: (<AuthLayout />),
  children: [
    {
      path: 'login',
      element: (<LoginActivity />)
    },
    {
      path: 'register',
      element: (<RegisterActivity />)
    },
    {
      path: 'register/:inviteCode',
      element: (<RegisterActivity />)
    }
  ]
};
